<div class="duplicate-records-container mat-elevation-z8 pb-1 example-table-container">
  <h2>Possible Duplicate Records Found</h2>
  <p>The following records match your entered information:</p>

  <table mat-table [dataSource]="duplicates" class="mat-elevation-z8" style="width:100%">
    <!-- Action Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef> Action </th>
      <td mat-cell *matCellDef="let element" class="flex-nowrap p-0">
        <div class="row col-sm-12">
          <div class="col-sm-8 p-2" *ngIf="element.reporting_Period === (desosreportinfo.mm + desosreportinfo.dd)">
            <!-- If the reporting period matches, show Edit button -->
            <button mat-stroked-button color="primary"
                    (click)="handleEditRecord(element.id, element.individual_ID)">
              Edit
            </button>
            <span style="display: block;font-size: 0.9em;padding-top: 5px;">{{splitUserEdit(element.user_Edit,0)}}</span>
            <span style="display: block;font-size: 0.9em;">{{splitUserEdit(element.user_Edit,1)}}</span>
          </div>
          <div class="col-sm-6 p-2" *ngIf="element.reporting_Period !== (desosreportinfo.mm + desosreportinfo.dd)">
            <!-- Otherwise, show New Outcome button -->
            <button mat-stroked-button color="primary"
                    (click)="handleNewOutcome(element.id, element.individual_ID)">
              New Outcome for {{ desosreportinfo.mm + '/' + desosreportinfo.dd }}
            </button>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Name </th>
      <td mat-cell *matCellDef="let element"> {{ element.lastName }} {{ element.firstName }} </td>
    </ng-container>

    <!-- City Column -->
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef> City </th>
      <td mat-cell *matCellDef="let element"> {{ element.city }} </td>
    </ng-container>

    <!-- County Column -->
    <ng-container matColumnDef="county">
      <th mat-header-cell *matHeaderCellDef> County </th>
      <td mat-cell *matCellDef="let element"> {{ element.county }} </td>
    </ng-container>

    <!-- DOB Column -->
    <ng-container matColumnDef="dateOfBirth">
      <th mat-header-cell *matHeaderCellDef> DOB </th>
      <td mat-cell *matCellDef="let element"> {{ element.dateOfBirth }} </td>
    </ng-container>

    <!-- Gender Column -->
    <ng-container matColumnDef="gender">
      <th mat-header-cell *matHeaderCellDef> Gender </th>
      <td mat-cell *matCellDef="let element"> {{ element.gender }} </td>
    </ng-container>

    <!-- Race Column -->
    <ng-container matColumnDef="race">
      <th mat-header-cell *matHeaderCellDef> Race </th>
      <td mat-cell *matCellDef="let element"> {{ element.race }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div class="duplicate-actions" style="margin-top:20px;">
    <button mat-button color="primary" (click)="onCancel()">Cancel</button>
  </div>
</div>
